import { IconButton, IconButtonProps, SvgIcon } from '@execonline-inc/execonline-ui';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { MouseEvent } from 'react';
import { VisibilityNavigationButton } from './Types';

interface Props extends IconButtonProps {
  visibility: VisibilityNavigationButton;
  disabled?: boolean;
  icon: typeof SvgIcon;
  onClick: (event?: MouseEvent<HTMLButtonElement>) => void;
}

function NavigationButton({ icon: Icon, disabled, visibility, onClick, ...others }: Props) {
  return (
    <div className="my-auto flex w-16 flex-shrink-0 justify-center">
      <IconButton
        className={clsx('h-full w-[30px] items-center py-1 text-font-size-4xl lg:w-10', {
          hidden: visibility === 'hide',
        })}
        disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        data-intercom-target="experience-carousel-navigation"
        onClick={onClick}
        {...others}
      >
        {<Icon color="black" size="inherit" disabled={disabled} />}
      </IconButton>
    </div>
  );
}

export default observer(NavigationButton);
